import { ICrudLocale } from '@app/i18n/interface';

export const PROVIDER_MANAGEMENT_LOCALE_ES: ICrudLocale = {
  PROVIDER: {
    LABEL: {
      SINGULAR: 'Proveedor',
      PLURAL: 'Proveedores',
    },
    FORM: {
      EDIT_DESCRIPTION:
        'Actualice la configuración operativa del proveedor seleccionado.',
      FETCH_ERROR:
        'Lo sentimos, ha ocurrido un error al obtener el proveedor.',
    },
    FIELD: {
      CODE: 'Código',
      NAME: 'Nombre',
      ENVIRONMENT: 'Entorno',
      TIMEOUT_MS: 'Timeout (ms)',
      TIMEOUT_MS_HINT:
        'Override del timeout por petición, entre {{ min }} y {{ max }} ms. Vacío usa el valor por defecto.',
      LABELS: 'Etiquetas',
      LABELS_HINT: 'Etiquetas operativas libres separadas por comas.',
      CREDENTIALS: 'Credenciales configuradas',
      ENABLED: 'Habilitado',
    },
    ENVIRONMENT: {
      PROD: 'Producción',
      TEST: 'Pruebas',
    },
    CREDENTIALS: {
      YES: 'Sí',
      NO: 'No',
    },
    LIST: {
      TITLE: 'Listado de proveedores',
    },
  },
};
